<template>
  <div class="pa-2 white text-left">
    <div class="pa-5">
      <v-text-field v-model="search" placeholder="search" outlined dense hide-details></v-text-field>
    </div>
    <div class="pl-5 pr-5 pt-2 pb-2" v-if="helpitems.length == 0">
      <v-alert type="info" text>No help found for search term '{{search}}'</v-alert>
    </div>
    <template v-for="(hitem,index) in helpitems">
      <AHelpItem :data="hitem" :key="index" class="ma-5"></AHelpItem>
    </template>
  </div>
</template>

<script>
import _ from "lodash";
import AHelpItem from "../components/AHelpItem";

let searchFn = (s1, s2) => {
  if (s1 === undefined || s2 === undefined) return false;
  return _.toLower(s1).indexOf(_.toLower(s2)) > -1;
};

export default {
  name: "Help",
  components: {
    AHelpItem
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    helpitems: function() {
      let items = [];
      let routes = this.$router.options.routes;
      routes.forEach(route => {
        if (route.meta && route.meta.help) {
          if (this.helpHasSearchTerm(route.meta.help, this.search))
            items.push(route.meta.help);
        }
      });
      return items;
    }
  },
  mounted() {
    console.log(this.$router.options.routes);
  },
  methods: {
    helpHasSearchTerm(help, term) {
      if (term.length == 0) return true;
      if (searchFn(help.title, term)) return true;
      for (let h = 0; help.items && h < help.items.length; h++) {
        const hitem = help.items[h];
        if (searchFn(hitem.title, term)) return true;
        for (let i = 0; hitem.body && i < hitem.body.length; i++) {
          const e = hitem.body[i];
          switch (e.type) {
            case "plain":
            case "html":
              if (searchFn(e.data, term)) return true;
              break;
            case "list":
              for (let j = 0; j < e.data.length; j++) {
                if (searchFn(e.data[j], term)) return true;
              }
              break;
            default:
              break;
          }
        }
      }
      return false;
    }
  }
};
</script>
